var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "accounting-document-amount-header",
      staticStyle: { width: "100%" }
    },
    [
      _c("div", [_vm._v(_vm._s(_vm.params.displayName))]),
      _c("div", { staticClass: "unit" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("FinanceManage.Billion")))]),
        _c("span", [_vm._v(_vm._s(_vm.$t("FinanceManage.Thousand")))]),
        _c("span", { staticClass: "blue" }, [
          _vm._v(_vm._s(_vm.$t("FinanceManage.Hundred")))
        ]),
        _c("span", [_vm._v(_vm._s(_vm.$t("FinanceManage.Ten")))]),
        _c("span", [_vm._v(_vm._s(_vm.$t("FinanceManage.TenThousand")))]),
        _c("span", [_vm._v(_vm._s(_vm.$t("FinanceManage.Thousand")))]),
        _c("span", { staticClass: "blue" }, [
          _vm._v(_vm._s(_vm.$t("FinanceManage.Hundred")))
        ]),
        _c("span", [_vm._v(_vm._s(_vm.$t("FinanceManage.Ten")))]),
        _c("span", { staticClass: "pink" }, [
          _vm._v(_vm._s(_vm.$t("FinanceManage.Yuan")))
        ]),
        _c("span", [_vm._v(_vm._s(_vm.$t("FinanceManage.Dime")))]),
        _c("span", [_vm._v(_vm._s(_vm.$t("FinanceManage.Cent")))])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }